import { push, ref, set, get } from 'firebase/database';
import { database } from '../firebaseConfig';

// "Photos are in" marketing task. Adds a task for the Marketing Manager on the listing's task list
// (transactions/{txId}/tasks, role 'Marketing Manager'), the same place and shape other team tasks use.
// No emails or texts are sent. Later, the residencemarketingteam@gmail.com inbox watcher will call this too.

export const photosInTaskName = (address) => `Photos are in for ${address || 'this listing'}: pay photographer and load to MLS`;

export const createPhotosInTask = async (txId, { address, createdBy = null, photosLink = '', source = 'manual' } = {}) => {
  if (!txId) throw new Error('Missing listing id');
  const name = photosInTaskName(address);
  // Skip if an open one already exists for this listing.
  const snap = await get(ref(database, `transactions/${txId}/tasks`));
  const existing = Object.values(snap.val() || {}).find((t) => t && t.name === name && t.status !== 'completed');
  if (existing) return { created: false, reason: 'already_exists' };
  const now = new Date().toISOString();
  await set(push(ref(database, `transactions/${txId}/tasks`)), {
    name,
    role: 'Marketing Manager',
    type: 'Task',
    appliesTo: 'All',
    anchor: null,
    offsetDays: 0,
    shared: false,
    action: null,
    mode: 'task',
    dueDate: now.slice(0, 10),
    status: 'pending',
    completedBy: null,
    completedAt: null,
    createdBy,
    createdAt: now,
    category: 'marketing',
    kind: 'photos-in',
    listingId: txId,
    photosLink: photosLink || '',
    source,
  });
  return { created: true, name };
};
